module.exports = __webpack_public_path__ + "img/logo-header.81d961ae.png";